if (!customElements.get('klaviyo-bis-modal')) {
  class KlaviyoBISModal extends ModalDialog {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.successMessage = this.querySelector('.js-popup-success-text');
      this.emailField = this.form.querySelector('input[type="email"]');
    }

    connectedCallback() {
      this.form.addEventListener('submit', this.onSubmitForm.bind(this));
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
    }

    onSubmitForm(event) {
      event.preventDefault();

      const data = JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.emailField.value
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${this.form.querySelector('[name="variant"]').value}`
              }
            }
          }
        }
      })

      fetch(this.form.getAttribute('action'),
        {
          method: "POST",
          headers: {
            "revision": '2024-06-15',
            "Content-Type": 'application/json'
          },
          body: data
        })
        .then((response) => {
          response.status == 202 ? this.formSubmited() : console.error('Error');
        })
        .catch((error) => console.error(error));
    }

    formSubmited() {
      this.successMessage.classList.remove('hidden');

      setTimeout(() => {
        this.hide();

        this.successMessage.classList.add('hidden');
        this.emailField.value = '';
      }, 4000);
    }
  }

  customElements.define('klaviyo-bis-modal', KlaviyoBISModal);
}